import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { agGridKey } from '../ag-grid-key';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { TennisSpinnerComponent } from './shared/components/tennis-spinner/tennis-spinner.component';
import { AppLoadingService } from './shared/services/app-loading.service';

LicenseManager.setLicenseKey(agGridKey);

ModuleRegistry.registerModules([AllEnterpriseModule]);

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TennisSpinnerComponent],
  templateUrl: './app.html',
})
export class App {
  protected readonly loading = inject(AppLoadingService);
}
